// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"d9a381eb","599":"c8a012cd","631":"f7e9055e","653":"f56baa47","731":"438a73e7","921":"e0647f0c","975":"49f8b19e"}[chunkId] + ".chunk.js";
};